



















































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'

// Components
import EditModalLayout from '@/components/common/modals/EditModalLayout.vue'

@Component({
  components: { EditModalLayout },
})
export default class CardEditModal extends Vue {
  @Prop()
  isOpen!: boolean

  @Prop()
  isNew!: boolean

  @Prop()
  data!: any

  formData: any = {}

  @Watch('formData')
  updateData() {
    this.$emit('update:data', this.formData)
  }

  beforeUpdate() {
    this.formData = { ...this.data }
  }
}
